var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-default',[_c('OTitle',[_vm._v("Status")]),(_vm.error)?_c('OAlert',{attrs:{"variant":"error"}},[_c('strong',[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")])]):_vm._e(),(_vm.code)?_c('CCodeStatus',{attrs:{"code":_vm.code}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }